import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Helmet } from "react-helmet-async";

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background px-6 text-center">
      <Helmet>
        <title>404 — Page not found · ClearSlot</title>
        <meta name="robots" content="noindex" />
      </Helmet>

      <Link to="/" className="flex items-center gap-2 mb-10" aria-label="ClearSlot home">
        <div className="relative h-8 w-8">
          <svg viewBox="0 0 100 100" className="h-full w-full">
            <defs>
              <linearGradient id="logoGrad404" x1="0%" y1="0%" x2="100%" y2="100%">
                <stop offset="0%" stopColor="hsl(190 100% 50%)" />
                <stop offset="100%" stopColor="hsl(210 70% 50%)" />
              </linearGradient>
            </defs>
            <circle cx="50" cy="50" r="46" stroke="url(#logoGrad404)" strokeWidth="2" strokeDasharray="10 5" fill="none" />
            <g transform="translate(10, 30) scale(0.36)">
              <path
                d="M40 55 C40 25 90 25 110 55 C130 85 180 85 180 55 C180 25 130 25 110 55 C90 85 40 85 40 55 Z"
                fill="none"
                stroke="url(#logoGrad404)"
                strokeWidth="18"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
          </svg>
        </div>
        <span className="text-xl font-bold text-foreground">ClearSlot</span>
      </Link>

      <h1 className="text-4xl md:text-5xl font-bold text-foreground mb-4">
        404 — Page not found
      </h1>
      <p className="text-lg text-muted-foreground mb-8 max-w-md">
        This page doesn't exist or has been moved.
      </p>
      <Button asChild variant="hero" size="lg">
        <Link to="/">Back to homepage</Link>
      </Button>
    </div>
  );
};

export default NotFoundPage;
